export default {
  name: 'marking--emissionType',
};